import React from 'react';
import CardsWithBtn from './CardsWithBtn';
import { HiOutlineBookOpen, HiOutlinePencilSquare, HiOutlineBriefcase, HiOutlineAcademicCap } from "react-icons/hi2";

const data = [
  {
    title: "Interview Experiences",
    description: "Dive into a wealth of interview experiences from different companies contributed by fellow students to ace your next big break.",
    btn: "Explore Now",
    url: '/posts',
    iconBg: "bg-blue-50 text-blue-600", 
    icon: <HiOutlineBookOpen size={40} />
  },
  {
    title: "Contribute Journey",
    description: "Share your valuable insights and interview rounds to guide and inspire your juniors in their career journey.",
    btn: "Share Story",
    url: '/create',
    iconBg: "bg-rose-50 text-rose-600",
    icon: <HiOutlinePencilSquare size={40} />
  },
  {
    title: "Job Openings",
    description: "Stay ahead with the latest job opportunities and off-campus drives tailored for students.",
    btn: "View Jobs",
    url: '/jobs',
    iconBg: "bg-amber-50 text-amber-600",
    icon: <HiOutlineBriefcase size={40} />
  },
  {
    title: "Study Resources",
    description: "Access curated notes, previous year papers, and practical files shared by the community for every branch.",
    btn: "Get Materials",
    url: '/resources',
    iconBg: "bg-emerald-50 text-emerald-600",
    icon: <HiOutlineAcademicCap size={40} />
  }
];

const Herom = () => {
  return (
    <div className='max-w-7xl mx-auto px-6 py-12'>
      {/* Changed to grid-cols-2 on medium and grid-cols-4 on large for a better fit */}
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
        {data.map((item, index) => (
          <CardsWithBtn 
            key={index}
            title={item.title} 
            description={item.description} 
            btn={item.btn} 
            url={item.url}
            iconBg={item.iconBg}
          >
            {item.icon}
          </CardsWithBtn>
        ))}
      </div>
    </div>
  );
}

export default Herom;